import { Component } from '@angular/core';


@Component({
  selector: 'app-health',
  template: '{{status}}'
})
export class HealthComponent {
  status = 'OK';
}